export default __webpack_public_path__ + "locales/az/InviteDialog.json?hash=97ce252c4717652c8e725dcaf370c2af";